import * as React from "react";
import {Box, Stack, Typography} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const PublishHeader = ({categorActive, setScreenToShow}) => {
    const {mode} = useDarkMode();
    return (
        <Stack direction={'row'}
               alignItems={'center'}
               spacing={5} sx={{marginLeft: {xs : '0px', md : '100px', lg :'100px'}}}
               flexWrap={'wrap'}
               gap={1}
        >
            <Typography
                variant={'subtitle1'}
                color={mode.settings.textColor3}
                width={{xs : '100%', md : 'auto', lg :'auto'}}
            >
                Publier :
            </Typography>
            <Stack direction={"row"} width={{xs : "100%", md : "25%", lg : "25%"}} alignItems={"center"} >
                {
                    categorActive === 'ACTUALITY' ?
                        <Stack className={'choiceButtonActive'} >
                            <img className={'iconChoice'} src={`/assets/icon/actuality-white.png`} alt={'Actualité'}/>
                        </Stack> :
                        <Stack className={'choiceButtonInactive'} onClick={() => setScreenToShow('ACTUALITY')}>
                            <img className={'iconChoiceInactive'} src={`/assets/icon/actuality-red.png`} alt={'Actualité'}/>
                        </Stack>
                }
                <Typography
                    variant={'subtitle1'}
                    className={'choiceTypo'}
                    color={mode.settings.textColor3}
                    width={{xs : '50%', md : 'auto', lg :'auto'}}
                >
                    Une actualité
                </Typography>
            </Stack>
            <Stack direction={"row"} width={{xs : "100%", md : "25%", lg : "25%"}} alignItems={"center"}>
                {
                    categorActive === 'EVENT' ?
                        <Stack className={'choiceButtonActive'}>
                            <img className={'iconChoice'} src={`/assets/icon/event-white.png`} alt={'Evenement'}/>
                        </Stack> :
                        <Stack className={'choiceButtonInactive'} onClick={(event) => {setScreenToShow('EVENT')}}>
                            <img className={'iconChoiceInactive'} src={`/assets/icon/event-red.png`} alt={'Evenement'}/>
                        </Stack>
                }
                <Typography variant={'subtitle1'} className={'choiceTypo'} color={mode.settings.textColor3}>
                    Un évènement
                </Typography>
            </Stack>

        </Stack>
    )
}

export default PublishHeader;
